import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=2cfba376&scoped=true&"
import script from "./reset-password.js?vue&type=script&lang=js&"
export * from "./reset-password.js?vue&type=script&lang=js&"
import style0 from "./reset-password.scss?vue&type=style&index=0&id=2cfba376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfba376",
  null
  
)

export default component.exports